import { createFileRoute } from "@tanstack/react-router";

import { SuspenseErrorComponent } from "~/components/error-states";
import { getProjectDetailsQuery } from "~/modules/project/network/queries";
import { ProjectDetailView } from "~/modules/project/views/project-detail";

export const Route = createFileRoute("/_app/projects/$projectId/")({
  component: RouteComponent,
  loader({ params, context: { queryClient } }) {
    queryClient.prefetchQuery(
      getProjectDetailsQuery.queryOptions(
        { params: { id: params.projectId } },
        { staleTime: Infinity }
      )
    );
  },
  pendingComponent: RoutePending,
  errorComponent: SuspenseErrorComponent,
});

function RouteComponent() {
  const { projectId } = Route.useParams();

  const { data } = getProjectDetailsQuery.useSuspenseQuery(
    {
      params: {
        id: projectId,
      },
    },
    { staleTime: Infinity }
  );

  return <ProjectDetailView project={data.project} />;
}

// having "empty" pending component keeps the shell rendering and just blank content
// we can add shell or other loading state in the future if we want
function RoutePending() {
  return null;
}
